module.exports = __webpack_public_path__ + "fbaf21bd96b7ebb9bcdc2752434645d8.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/grey.png
// module id = 2153
// module chunks = 0